import { useState } from "react";
import { Upload, Loader2, X } from "lucide-react";
import { toast } from "sonner";
import { api, resolveImg } from "../../lib/api";

export const ImageUpload = ({ value, onChange }) => {
  const [uploading, setUploading] = useState(false);

  const handle = async (e) => {
    const file = e.target.files?.[0];
    if (!file) return;
    setUploading(true);
    const fd = new FormData();
    fd.append("file", file);
    try {
      const { data } = await api.post("/upload", fd, { headers: { "Content-Type": "multipart/form-data" } });
      onChange(data.url);
      toast.success("Image uploaded");
    } catch {
      toast.error("Upload failed");
    }
    setUploading(false);
  };

  return (
    <div>
      {value ? (
        <div className="relative w-full h-40 rounded-lg overflow-hidden border border-white/10 group">
          <img src={resolveImg(value)} alt="preview" className="w-full h-full object-cover" />
          <button type="button" onClick={() => onChange("")} className="absolute top-2 right-2 grid place-items-center w-8 h-8 rounded-full bg-black/70 text-white opacity-0 group-hover:opacity-100 transition-opacity"><X size={16} /></button>
        </div>
      ) : (
        <label className="flex flex-col items-center justify-center gap-2 w-full h-40 rounded-lg border border-dashed border-white/20 cursor-pointer hover:border-[#E63946] transition-colors text-white/50">
          {uploading ? <Loader2 className="animate-spin" /> : <Upload size={22} />}
          <span className="text-sm">{uploading ? "Uploading…" : "Click to upload image"}</span>
          <input type="file" accept="image/*" className="hidden" onChange={handle} data-testid="image-upload-input" />
        </label>
      )}
    </div>
  );
};
